import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useCreateGroupMutation } from '@/api/v1';
import { ApplicationModal } from '@/components/organisms/ApplicationModal';
import { CreateGroupForm } from '@/components/organisms/CreateGroupForm';
import type { CreateGroupRequest } from '@/DTOs/groups';
import { useTranslator } from '@/hooks/useTranslator';

export const CreateGroupModal: React.FC = (): React.ReactElement => {
  const [createGroup] = useCreateGroupMutation();

  const tr = useTranslator();
  const navigate = useNavigate();

  const onClose = React.useCallback((): void => {
    navigate('..');
  }, [navigate]);

  const onSubmit = React.useCallback(
    async (data: CreateGroupRequest): Promise<void> => {
      try {
        await createGroup(data).unwrap();
      } catch (error) {
        console.error('Failed to create group:', error);
      }
    },
    [createGroup],
  );

  return (
    <ApplicationModal title={tr('ADD_NEW_ROLE')} variant="prominent" onClose={onClose}>
      <CreateGroupForm onSubmit={onSubmit} />
    </ApplicationModal>
  );
};
